function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-.869-1.333h17.28v17.28H-.869z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M6.697 6.98L12.173.758a.75.75 0 0 1 1.075-.059.79.79 0 0 1 .057 1.099L8.285 7.5l5.02 5.702a.79.79 0 0 1-.057 1.099.75.75 0 0 1-1.075-.059L6.697 8.02a.789.789 0 0 1 0-1.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M.697 6.98L6.173.758A.75.75 0 0 1 7.248.699a.79.79 0 0 1 .057 1.099L2.285 7.5l5.02 5.702a.79.79 0 0 1-.057 1.099.75.75 0 0 1-1.075-.059L.697 8.02a.789.789 0 0 1 0-1.04z"
}));

const SvgIcToggleSidebar = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcToggleSidebar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-toggle-sidebar.7c9850ce.svg";
export { ForwardRef as ReactComponent };